import React from 'react';
import {NavLink, Route, Routes, useParams} from "react-router-dom";
import Main from "./Main";
import Insert from './insert/Index'
import Reports from './xisobotlar/Index'
import Limits from './limit/Index'
import {ExcelPrint} from "../../../../../../components/functions/Print";
import excel from "../../../../../../icons/excel.png";
function Index(props) {
    let params = useParams()
    const page = (p) => {
        switch (p){
            case '': return 'Asosiy'
            case 'insert': return 'Ma\'lumot kiritish'
            case 'insert/manbalar': return 'Ma\'lumot kiritish'
            case 'insert/istemolchilar': return 'Ma\'lumot kiritish'
            case 'insert/ste': return 'Ma\'lumot kiritish'
            case 'insert/maydon': return 'Ma\'lumot kiritish'
            case 'insert/limit': return 'Ma\'lumot kiritish'
            case 'reports': return 'Xisobotlar'
            case 'limits': return 'Limitlar'
            default: return 'Asosiy'
        }
    }
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="content-top-box" style={{marginLeft:"-20px",marginRight:"-20px"}}>
                        <ul className="content-top-left">
                            <li>Suvdan foydalanish rejasini ishlab chiqish - {page(params['*'])}
                            </li>
                        </ul>
                        <ul className="content-top-right">
                            <button className="btn p-0" onClick={()=>ExcelPrint("Asosiy nuqtalar", "Xisobot №1","tblData")}>
                                <img src={excel} alt="404"/>
                            </button>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <Routes>
                        <Route path="/" element={<Main />}/>
                        <Route path="/insert/*" element={<Insert />}/>
                        <Route path="/reports/*" element={<Reports />}/>
                        <Route path="/limits/*" element={<Limits />}/>
                    </Routes>
                </div>
            </div>
        </div>

    );
}

export default Index;